import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./layout/Navbar";
import NotificationBar from "./components/NotificationBar";
import Footer from "./layout/Footer";
import Home from "./pages/Home";
import Courses from "./pages/Courses";
import Internships from "./pages/Internships";
import CourseDetails from "./pages/CourseDetails";
import InternshipDetails from "./pages/InternshipDetails";

function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <NotificationBar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />

          <Route path="/courses" element={<Courses />} />
          <Route path="/internships" element={<Internships />} />

          <Route path="/courses/:slug" element={<CourseDetails />} />
          <Route path="/internships/:slug" element={<InternshipDetails />} />
        </Routes>
      </main>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
